import api from "../utils/API";

// Base URL for your API
export const salesService = {
  fetchList: async (payload) => {
    try {
      const response = await api.get("/admin/sales-rep", { params: payload });
      return response?.data;
    } catch (error) {
      return error.response.data;
    }
  },

  fetchOptionList: async () => {
    try {
      const response = await api.get("/admin/sales-rep/all");
      return response?.data;
    } catch (error) {
      return error.response.data;
    }
  },

  createSalesRep: async (payload) => {
    try {
      const response = await api.post("/admin/sales-rep", payload);
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },

  updateSalesRep: async (id, payload) => {
    try {
      const response = await api.put(`/admin/sales-rep/${id}`, payload);
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },
  deleteSalesRep: async (id) => {
    try {
      const response = await api.delete(`/admin/sales-rep/${id}`);
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },
  fetchSalesRepById: async (id) => {
    try {
      const response = await api.get(`/admin/sales-rep/${id}`);
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },
  resendInvitation: async (id) => {
    try {
      const response = await api.put(`/admin/sales-rep/resend-invitation/${id}`);
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },
  assignDealers: async (id, payload) => {
    try {
      const response = await api.post(`/admin/sales-rep/${id}/dealers`, payload);
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },
  setTarget: async (id, payload) => {
    try {
      const response = await api.post(`/admin/sales-rep/${id}/target`, payload);
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },
  getTargetBySalesId: async (id, payload) => {
    try {
      const response = await api.get(`/admin/sales-rep/${id}/target`, { params: payload });
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },
};
